import { Component } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { EBillCoreActions, EBillCoreSelectors, fromEBillCore } from '@ruby/modules/ebill/store/ebill-core.index';
import { EBillDashboardActions } from '@ruby/modules/ebill/store/ebill-dashboard.index';
import { EBillScreen } from '@ruby/shared/enums/ebill.enums';
import { IEBillProfile, IEBillSearchTypes } from '@ruby/shared/models/ebill/ebil.interface';

@Component({
  selector: 'ng-ebill-header-container',
  templateUrl: './ebill-header.container.html',
  styleUrls: ['./ebill-header.container.scss']
})
export class EBillHeaderContainer {
  userRacf!: string;
  store$!: Observable<{ state: fromEBillCore.State; userRacf?: string }>;

  constructor(private store: Store<{ state: fromEBillCore.State; userRacf?: string }>) {
    this.store$ = this.store.select(EBillCoreSelectors.selectCoreState).pipe(tap((st: { state: fromEBillCore.State; userRacf?: string }) => {
      if (st.userRacf && this.userRacf !== st.userRacf) {
        this.userRacf = st.userRacf;
        this.loadHeader();
      }
    }));
  }

  /**
   * Dispatch set selected profile
   *
   * @summary Dispatch set selected profile
   * @param $profile: IEBillProfile
   * @returns void
   */
  setSelectedProfile($profile: IEBillProfile): void {
    this.store.dispatch(EBillCoreActions.setSelectedProfile({ data: $profile }));
  }

  /**
   * Dispatch set alternate user
   *
   * @summary Dispatch set alternate user
   * @param $user: string
   * @returns void
   */
  setAlternateUser($user: string): void {
    this.store.dispatch(EBillCoreActions.setAlternateUser({ data: $user }));
  }

  /**
   * Dispatch Validate Racf
   *
   * @summary dispatch validate racf
   * @param $user: string
   * @returns void
   */
  dispatchValidateRacf($user: string): void {
    this.store.dispatch(EBillCoreActions.validateRacf({ data: $user }));
  }

  /**
   * Dispatch Search Bill
   *
   * @summary Dispatch Search Bill
   * @param $event: { searchType: IEBillSearchTypes; value: string }
   * @returns void
   */
  dispatchSearchBill($event: { searchType: IEBillSearchTypes; value: string }): void {
    switch ($event.searchType.screen) {
      case EBillScreen.Details:
        this.saveCriteria(JSON.stringify({
          directionType: 'ASC',
          page: 1,
          searchType: $event.searchType.type,
          label: $event.searchType.label.toUpperCase(),
          value: $event.value,
          sortColumn: [],
          userRacf: this.userRacf,
          isFilter: true
        }));
        break;
      case EBillScreen.Email:
        this.saveCriteria(JSON.stringify({
          searchEmailType: $event.searchType.type,
          value: $event.value,
          userRacf: this.userRacf
        }), 'profiles');
        break;
      case EBillScreen.Customer:
        this.saveCriteria(JSON.stringify({
          searchCustomerType: $event.searchType.type,
          value: $event.value,
          userRacf: this.userRacf
        }), 'locations');
        break;
    }
  }

  private saveCriteria(params: string, route?: string): void {
    this.store.dispatch(EBillDashboardActions.saveCriteria({ data: { durationInMinutes: 360, parameters: { eBill: params } }, route }));
  }

  private loadHeader(): void {
    this.store.dispatch(EBillCoreActions.loadHeader({ data: this.userRacf }));
    this.store.dispatch(EBillCoreActions.loadUser({ data: this.userRacf }));
  }
}
